import { getArray } from '../../../utils/helpers';

import SignatureDishImg from "../../../assets/signature_dish.png"
import leftImage from '../../../assets/leave-3.png';

const SignatureDish = ({t}) => {
    const { dish } = t
    return (
        <section className="py-20 bg-[#FFF]">
            <div className="container mx-auto px-4">
                <div className="flex flex-wrap items-center">
                    <div className="w-full md:w-1/2 mb-10 md:mb-0">
                        <img 
                            src={SignatureDishImg} 
                            alt="Signature Dish" 
                            className="rounded-lg shadow-xl"
                            width={500}
                            height={750}
                            layout="responsive"
                        />
                    </div>
                    <div className="w-full md:w-1/2 md:pl-10">
                        <div className="relative">
                            <h5 className="text-[#C7702A] uppercase mb-2 font-['Jost',sans-serif] text-[15px] font-normal">{dish?.title}</h5>
                            <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[40px] font-medium tracking-[-0.6px] leading-[48px] mb-6">{dish?.subtitle}</h2>
                            {/* <p className="text-[rgba(31,7,7,0.62)] font-['__Jost_461405'] text-[18px] font-normal leading-[28.8px] text-left mb-6">Experience a masterful fusion of Italian and Japanese flavors with a menu crafted by a Michelin-starred Italian chef. This exclusive selection blends the elegance of Italian cuisine with the deep umami of Japanese ingredients, creating a truly unique and unforgettable dining experience.</p> */}
                            <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[30px] font-medium tracking-[-0.6px] leading-[48px]">{dish?.ingredients}</h2>
                            <ul className="space-y-4 mb-8">
                                {getArray(dish?.ingredients_list).map((item, index) => (
                                    <li key={index} className="flex items-start">
                                        <span className="text-[#C7702A] text-primary-500 mr-2">■</span>
                                        <span className="text-[rgba(31,7,7,0.62)] font-['__Jost_461405'] text-[18px] font-normal leading-[28.8px]">
                                            <p>{item}</p>
                                        </span>
                                    </li>
                                ))}
                            </ul>
                            <h2 className="text-[#1F0707] font-['__Libre_Caslon_Display_20614e'] text-[30px] font-medium tracking-[-0.6px] leading-[48px]">{dish?.method}</h2>
                            <ul className="space-y-4 mb-8">
                                {getArray(dish?.steps).map((item, index) => (
                                    <li key={index} className="flex items-start">
                                        <span className="text-[#C7702A] text-primary-500 mr-2">■</span>
                                        <span className="text-[rgba(31,7,7,0.62)] font-['__Jost_461405'] text-[18px] font-normal leading-[28.8px]">
                                            <strong className='text-[#1F0707]'>{item.title}</strong>
                                            <p>{item.description}</p>
                                        </span>
                                    </li>
                                ))}
                            </ul>
                            <p className="relative z-10 text-[rgba(31,7,7,0.62)] font-['__Jost_461405'] text-[18px] font-normal leading-[28.8px] text-left mb-6">{dish?.message}</p>
                            <div
                                className="absolute inset-0 z-0 bg-no-repeat bg-center bg-contain opacity-35"
                                style={{
                                    backgroundImage: `url(${leftImage.src})`,
                                    transform: 'rotate(48deg) scale(0.6)',
                                }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SignatureDish;